import React from 'react'
import PropTypes from 'prop-types'
import MENU_ITEMS from './MENU_ITEMS'
import MenuLink from './MenuLink'

const MenuItems = ({ type, action, label, onClick }) => {
  const trackLink = item => {
    onClick(action, label || item.label)
  }

  return (
    MENU_ITEMS[type].map(item => (
      <li key={item.id}>
        <MenuLink
          onClick={() => trackLink(item)}
          {...item}
        >{item.label}</MenuLink>
      </li>
    ))
  )
}

MenuItems.defaultProps = {
  action: null,
  label: null
}

MenuItems.propTypes = {
  type: PropTypes.string.isRequired,
  action: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

export default MenuItems
